<template>
  <v-container fluid class="pa-0">
    <v-row class="header-section position-relative">
      <v-col cols="2" class="align-items-center d-none d-sm-block">
          <v-img
            :src="require('@/assets/img/icons/challenge-detail/treasure-home.png')"
            height="120"
            width="145"
            class="img-titles-absolute">
          </v-img>
        </v-col>
        <v-col>
          <h3>{{ $t('home.complete_the_events') }}</h3>
          <p>{{ $t('home.get_beecoins_and_xp') }}</p>
        </v-col>
    </v-row>
    <v-card class="px-2 py-2 events-card" elevation="0" v-for="(event, i) in achievementEvents" :key="i">
      <v-row  no-gutters>
        <v-col cols="3" md="2" class="align-self-center">
          <v-img
            height="60"
            width="60"
            class="icon mx-auto"
            :src="require(`@/assets/img/gamifications/${event.imageName}`)">
          </v-img>
        </v-col>
        <v-col cols="9" md="10" class="text-left">
          <v-row class="ma-0">
            <v-col class="pa-0">
              <v-chip
                label
                x-small
                color="primary"
                class="font-weight-bold px-2 py-2 text-uppercase"
              >Lectura</v-chip>
            </v-col>
            <v-col class="pa-0 text-right">
              <v-chip
                label
                x-small
                :color="isActiveEvent(event) ? '#6857B21A' : '#F2A80D26'"
                :text-color="isActiveEvent(event) ? '#7764CA' : '#F2A80D'"
                class="font-weight-bold px-1 py-2 text-uppercase"
              >
                <v-img
                  contain
                  height="8"
                  width="7"
                  :class="isActiveEvent(event) ? 'purple-icon' : 'yellow-icon'"
                  :src="isActiveEvent(event) ? purpleClockIcon : yellowClockIcon"
                ></v-img>
                <span> {{ generateDaysToCompleteText(event) }}</span>
              </v-chip>
            </v-col>
          </v-row>

          <h4>{{ event.eventName}}</h4>
          <p class="mb-1"><small>{{event.description}}</small></p>

          <div class="progress-bar mb-1 pr-1">
            <div class="progress-bar__container">
              <v-progress-linear
                dark
                background-color="#EEECF8"
                color="#514585"
                :value="completedTasksPercentage(event)"
                height="15"
                rounded
              >
                <strong>{{ $t('home.items_to_items', { actual: event.progress , toComplete: event.totalToComplete }) }}</strong>
              </v-progress-linear>

            <!-- componente alert -->
                <v-btn
                  icon
                  class="tooltip-button-hover"
                  @click="toggleTooltip(i)"
                  >
                  <v-img
                    contain
                    max-height="30"
                    max-width="30"
                    class=""
                    :src="treasure"
                  />
                  <v-img
                      contain
                      max-height="30"
                      max-width="30"
                      class="rewards-icon"
                      :src="claimReward"
                      v-if="event.isCompleted && !event.rewardWasCollected"
                    />
                </v-btn>
                <v-alert
                  :value="show[i]"
                  color=""
                  dense
                  class="tooltip"
                  transition="scale-transition"
                >
                  <v-row class="tooltip__header">
                      <v-col offset="2" cols="8" class="pt-1 pb-1 text-center text-no-wrap">
                        {{ $t('home.rewards')}}
                      </v-col>
                      <v-col cols="2" class="py-1 px-2">
                        <span
                          class="tooltip__close"
                          @click="closeBtnTooltip(i)">
                          <v-icon class="font-size-14 white rounded-circle cursor-pointer">mdi-close-circle</v-icon>
                        </span>
                      </v-col>
                  </v-row>
                  <v-row class="px-4">
                    <v-col cols="5" class="px-0 py-2 text-right">
                      <div class="tooltip__item d-inline-flex">
                        <v-img
                            max-height="30"
                            max-width="30"
                            class="icon"
                            :src="xpIcon">
                        </v-img>
                        <span class="align-self-center ml-1"> 50 </span>
                      </div>
                    </v-col>
                    <v-col cols="2" class="pa-0 d-flex align-items-center justify-content-center">
                      <span class="only-text">+</span>
                    </v-col>
                    <v-col cols="5" class="px-0 py-2 text-left">
                      <div class="tooltip__item d-inline-flex">
                        <v-img
                          max-height="30"
                          max-width="30"
                          class="icon"
                          :src="beecoinIcon">
                        </v-img>
                        <span class="align-self-center ml-1"> 50 </span>
                      </div>
                    </v-col>
                </v-row>
                <v-row class="px-4">
                    <v-col cols="12" class="px-0 pt-0">
                      <v-btn
                        outlined
                        block
                        color="primary"
                        class="tooltip__button"
                        @click="collectRewards(i)"
                        v-if="event.isCompleted"
                        >
                        {{ $t('home.get') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
            <!-- componente alert -->

              </div>
            </div>

        </v-col>
      </v-row>
    </v-card>

  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GamificationService from '@/services/gamification'

export default {
  data: () => ({
      calendarIcon: require('@/assets/img/icons/calendar.png'),
      yellowClockIcon: require('@/assets/img/icons/icon-yellow-clock.svg'),
      purpleClockIcon: require('@/assets/img/icons/icon-purple-clock.svg'),
      treasure: require('@/assets/img/icons/treasure-stroke.png'),
      claimReward: require('@/assets/img/icons/claim-reward.png'),
      xpIcon: require('@/assets/img/icons/xp-coin.png'),
      beecoinIcon: require('@/assets/img/icons/beecoins.png'),
      show: new Array(2).fill(false),
    }),
  computed: {
    ...mapState('userData', ['user']),
    ...mapState('events', ['achievementEvents']),
  },
  mounted() {
    this.fetchAchievementEventsByUser(this.user.id)
  },
  methods: {
    ...mapActions('events', ['fetchAchievementEventsByUser', 'collectReward']),
    ...mapActions('userData', ['setGamification']),

    toggleTooltip(index) {
      if (!this.achievementEvents[index].rewardWasCollected) {
        // this.$set(this.show, index, true)
        // abrir tootltip uno a la vez
        this.show = this.show.map((_, i) => i === index);
      } else {
        if(this.achievementEvents[index].isCompleted && this.achievementEvents[index].rewardWasCollected){
          this.$modal.rewards(
            '', this.$t('home.reward_already_awarded')
          )
        } else {
          this.$modal.error(
            this.$t('home.challenge_hasnt_been_completed')
          )
        }
      }
    },
    closeBtnTooltip(index) {
      this.$set(this.show, index, false)
    },
    async collectRewards(index) {
      try {
        const payload = {
          eventId: this.achievementEvents[index].eventId,
          userId: this.user.id
        }

        const isChallengeCompleted = await this.collectReward(payload)

        if (isChallengeCompleted) {
          await this.updateGamificationStats()
          this.$set(this.show, index, false)
          this.$modal.rewards(
            this.$t('home.congrats'),
            this.$t('home.reward_earned')
          )
        } else {
          this.$modal.error(this.$t('home.challenge_hasnt_been_completed'))
        }
      } catch (e) {
        this.$modal.loadError()
        console.log('Error: ', e);
      }
    },
    completedTasksPercentage(achievementEvent) {
      return (achievementEvent.progress / achievementEvent.totalToComplete) * 100;
    },
    isActiveEvent(event) {
      return event.daysToExpiry > 0 && !event.rewardWasCollected
    },
    generateDaysToCompleteText(event) {
      return this.isActiveEvent(event) ?
        this.$tc('home.number_of_days', event.daysToExpiry, { count: event.daysToExpiry })
        : `${this.$t('home.starts_in')} ${this.$tc('home.number_of_days', event.daysToStart, { count: event.daysToStart })}`
    },
    async updateGamificationStats() {
      GamificationService.getUserGameStatsByUser(this.user.id)
        .then((response) => {
          if (response.content.id) {
            this.setGamification(response.content)
          }
        })
        .catch((error) => console.error(error))
    },
  }
}
</script>

<style lang="scss" scoped>
.events-card{
  background: linear-gradient(270deg, rgba(238, 236, 248, 0.4) 0%, rgba(238, 236, 248, 0.4) 69.16%, rgba(255, 255, 255, 0.4) 102.9%);
  border: 1px solid #EEECF8;
  border-radius: 0;
  &:nth-child(2){
    border-radius: 12px 12px 0 0;
  }
  &:last-child{
    border-radius: 0 0 12px 12px;
  }

  p{
    line-height: 80%;
    small{
      font-size: 70%;
    }
  }
}
::v-deep .v-progress-linear__content{
  color: #C4BBE7;
}

.v-chip{
  .v-image{
    margin-right: 2px;
  }
  &.v-size--x-small{
    font-size: 9px;
  }

}
.img-titles-absolute{
  position: absolute;
  top: -25px;
  left: -1em;
}
</style>